import { useState } from 'react';
import styled from 'styled-components';

const StyledSection = styled.section`
  fontfamily: 'Poppins, sans-serif';
  .overlay:before {
    background: ${({ landingPrimaryColor }) => landingPrimaryColor} !important;
  }
`;

const StyledButton = styled.span`
  button {
    background-color: ${({ landingPrimaryColor }) =>
      landingPrimaryColor} !important;
  }
  &:hover {
    button {
      background-color: ${({ landingSecondaryColor }) =>
        landingSecondaryColor} !important;
    }
  }
`;

const Contact = ({
  landingPrimaryColor,
  landingSecondaryColor,
  firmName,
  firmAddress,
  gstNumber,
  appPhoneNumber,
  appEmailAddress,
  mapLocation,
}) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  return (
    appPhoneNumber && (
      <StyledSection landingPrimaryColor={landingPrimaryColor}>
        <section id="contact-link" class="contact-us section">
          <div class="container">
            <div class="inner">
              <div class="row">
                <div class="col-lg-6">
                  <div class="contact-us-left">
                    <iframe
                      src={mapLocation}
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowfullscreen=""
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="contact-us-form">
                    <h2>Contact With Us</h2>
                    <p>
                      If you have any questions please fell free to contact with
                      us.
                    </p>

                    <form
                      class="form"
                      method="POST"
                      action={`https://wa.me/${appPhoneNumber}?text=${name}, ${email}, ${phone}, ${subject}, ${message}`}
                      onSubmit={(e) => {
                        e.preventDefault();
                        if (!name) {
                          alert('Please enter your fullname');
                        } else if (!email) {
                          alert('Please enter your email');
                        } else if (!phone) {
                          alert('Please enter your phone');
                        } else if (!subject) {
                          alert('Please enter your subject');
                        } else if (!message) {
                          alert('Please enter your message');
                        } else {
                          window.location.href = `https://wa.me/${appPhoneNumber}?text=${encodeURIComponent(
                            `*Full Name:* ${name}, *Email:* ${email}, *Phone:* ${phone}, *Subject:* ${subject}, *Message:* ${message}`
                          )}`;
                        }
                      }}
                    >
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="form-group">
                            <input
                              type="text"
                              placeholder="Full Name"
                              required=""
                              value={name}
                              onChange={(e) => {
                                e.preventDefault();
                                setName(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="form-group">
                            <input
                              type="email"
                              placeholder="Email"
                              required=""
                              value={email}
                              onChange={(e) => {
                                e.preventDefault();
                                setEmail(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="form-group">
                            <input
                              type="text"
                              placeholder="Phone"
                              required=""
                              value={phone}
                              onChange={(e) => {
                                e.preventDefault();
                                setPhone(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="form-group">
                            <input
                              type="text"
                              name="subject"
                              placeholder="Subject"
                              required=""
                              value={subject}
                              onChange={(e) => {
                                e.preventDefault();
                                setSubject(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div class="col-lg-12">
                          <div class="form-group">
                            <textarea
                              name="message"
                              placeholder="Your Message"
                              required=""
                              value={message}
                              onChange={(e) => {
                                e.preventDefault();
                                setMessage(e.target.value);
                              }}
                            ></textarea>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group login-btn">
                            <StyledButton
                              landingPrimaryColor={landingPrimaryColor}
                              landingSecondaryColor={landingSecondaryColor}
                            >
                              <button class="btn" type="submit">
                                Send
                              </button>
                            </StyledButton>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-info">
              <div class="row">
                <div class="col-lg-6 col-12 ">
                  <div class="single-info">
                    <div class="content">
                      <h3>{appPhoneNumber}</h3>
                      <p>
                        <a href={`mailto:${appEmailAddress}`}>
                          {appEmailAddress}
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-12 ">
                  <div class="single-info">
                    <div class="content">
                      <h3>{firmName}</h3>
                      <p>{firmAddress}</p>
                      <p>{gstNumber}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </StyledSection>
    )
  );
};

export default Contact;
